import { render, staticRenderFns } from "./DriverManifestModal.vue?vue&type=template&id=672ce289"
import script from "./DriverManifestModal.vue?vue&type=script&lang=ts"
export * from "./DriverManifestModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports